import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Bunları ekledik
import styles from '../css/Navbar.module.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const closeMenu = () => setIsOpen(false);

    // Akıllı Kaydırma Fonksiyonu
    const handleNavClick = (id) => {
        closeMenu();

        const performScroll = () => {
            const element = document.getElementById(id);
            if (element) {
                // Elemanın 80px yukarısına odaklan (Navbar başlığı kapatmasın diye)
                const yOffset = -80;
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        };

        if (location.pathname === '/') {
            // Zaten ana sayfadaysak direkt kaydır
            performScroll();
        } else {
            // Başka sayfadaysak (detay sayfası gibi) önce ana sayfaya git
            navigate('/');
            // Sayfanın yüklenmesi için 300ms bekle sonra kaydır
            setTimeout(() => {
                performScroll();
            }, 300);
        }
    };

    return (
        <nav className={styles.navbar}>
            <div className={styles.container}>

                {/* Logo - Tıklayınca ana sayfaya ve en tepeye atar */}
                <div className={styles.logoContainer}>
                    <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                        <img
                            src="/assets/img/huzurlogo.png"
                            alt="AKC Motor Logo"
                            className={styles.logo}
                        />
                    </Link>
                </div>

                {/* Menü Linkleri */}
                <ul className={`${styles.navLinks} ${isOpen ? styles.active : ''}`}>
                    <li onClick={() => {
                        closeMenu();
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}>
                        <Link to="/">Anasayfa</Link>
                    </li>
                    <li onClick={() => handleNavClick('services')}><a>Hizmetler</a></li>
                    <li onClick={() => handleNavClick('gallery')}><a>Galeri</a></li>
                    <li onClick={() => handleNavClick('contact')}><a>İletişim</a></li>

                    <li className={styles.mobileOnly}>
                        <button className={styles.contactBtn}>
                            <Phone size={18} /> Hemen Ara
                        </button>
                    </li>
                </ul>

                <div className={styles.desktopOnly}>
                    <a href="tel:+905426429466" className={styles.contactBtn}>
                        <Phone size={18} /> 0542 642 94 66
                    </a>
                </div>

                <div className={styles.hamburger} onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? <X size={28} /> : <Menu size={28} />}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;